import { styled, css } from "styled-components";

const MESSAGE_SAVE_USERNAME_TYPE = {
  POST_VISIBLE: css`
    color: ${({ theme }) => theme?.colors?.text?.paragraph};
    div {
      color: ${({ theme }) => theme?.colors?.theme?.info};
    }
  `,
  USERNAME_NOT_FOUND: css`
    color: ${({ theme }) => theme?.colors?.theme?.error};
    div {
      color: ${({ theme }) => theme?.colors?.theme?.error};
    }
  `,
  CUSTOM_ERROR: css`
    color: ${({ theme }) => theme?.colors?.theme?.error};
    div {
      color: ${({ theme }) => theme?.colors?.theme?.error};
    }
  `,
  VERIFY_HASH: css`
    color: ${({ theme }) => theme?.colors?.theme?.warning};
    div {
      color: ${({ theme }) => theme?.colors?.theme?.warning};
    }
  `,
  POST_ALREADY_EXIST: css`
    color: ${({ theme }) => theme?.colors?.theme?.warning};
    div {
      color: ${({ theme }) => theme?.colors?.theme?.warning};
    }
  `,
  URL_INVALID: css`
    color: ${({ theme }) => theme?.colors?.theme?.error};
    div {
      color: ${({ theme }) => theme?.colors?.theme?.error};
    }
  `,
  SAVE_URL: css`
    color: ${({ theme }) => theme?.colors?.text?.paragraph};
    div {
      color: ${({ theme }) => theme?.colors?.theme?.info};
    }
  `,
  URL_NOT_FOUND: css`
    color: ${({ theme }) => theme?.colors?.theme?.warning};
    div {
      color: ${({ theme }) => theme?.colors?.theme?.warning};
    }
  `,
  URL_ALREADY_EXIST: css`
    color: ${({ theme }) => theme?.colors?.theme?.warning};
    div {
      color: ${({ theme }) => theme?.colors?.theme?.warning};
    }
  `,
  DEFAULT: css`
    color: ${({ theme }) => theme?.colors?.text?.paragraph};
    div {
      color: ${({ theme }) => theme?.colors?.theme?.info};
    }
  `,
} as const;

export const NoteContainerStyled = styled.div<{ $typePost: string}>`
  display: flex;
  height: 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  ${({ $typePost })=> MESSAGE_SAVE_USERNAME_TYPE?.[$typePost as keyof typeof MESSAGE_SAVE_USERNAME_TYPE] || MESSAGE_SAVE_USERNAME_TYPE.DEFAULT}
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 14px */

  img {
    width: 16px;
    height: 16px;
  }
`